import { LOGIN_PATH, USER_PASSWORD_RECOVERY_PAGE } from '../../constants/paths';
import { Login, loginLoader } from './login';


const loginRoutes = [
  {
      path: LOGIN_PATH,
      element: <Login key='login' isRecoveryPath={false} />,
      loader: loginLoader,
      // action: complaintCaseAction
  },
  {
      path: `${USER_PASSWORD_RECOVERY_PAGE}:authHash`,
      element: <Login key='login:password_recovery' isRecoveryPath={true} />,
  },
];

export default loginRoutes;